<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from '@/composable/useI18n'

const { t } = useI18n()

interface Props {
  modelValue: {
    name: string
    mac_address: string
    subid: string
    status: string
  }
  errors: { [key: string]: string | undefined }
}

interface Emits {
  (e: 'update:modelValue', value: Props['modelValue']): void
}

const props = defineProps<Props>()
const emit = defineEmits<Emits>()

const formData = computed({
  get: () => props.modelValue,
  set: (value) => emit('update:modelValue', value),
})
</script>

<template>
  <div class="space-y-4">
    <div>
      <label for="name" class="block text-sm font-medium"> Sensor Name </label>
      <input
        v-model="formData.name"
        type="text"
        id="name"
        class="mt-1 block w-full border border-bodydark2 px-3 py-2 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
        :placeholder="t('placeholders.sensors.example')" />
      <div v-if="errors.name" class="text-sm text-red">
        {{ errors.name }}
      </div>
    </div>

    <div>
      <label for="mac_address" class="block text-sm font-medium"> MAC Address </label>
      <input
        v-model="formData.mac_address"
        type="text"
        id="mac_address"
        class="mt-1 block w-full border border-bodydark2 px-3 py-2 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm" />
      <div v-if="errors.mac_address" class="text-sm text-red">
        {{ errors.mac_address }}
      </div>
    </div>

    <div>
      <label for="subid" class="block text-sm font-medium"> SubID </label>
      <input
        v-model="formData.subid"
        type="text"
        id="subid"
        class="mt-1 block w-full border border-bodydark2 px-3 py-2 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm" />
      <div v-if="errors.subid" class="text-sm text-red">
        {{ errors.subid }}
      </div>
    </div>

    <div>
      <label for="status" class="block text-sm font-medium"> Status </label>
      <select
        v-model="formData.status"
        id="status"
        class="mt-1 block w-full border border-bodydark2 px-3 py-2 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm">
        <option value="activated">Ativo</option>
        <option value="disabled">Inativo</option>
      </select>
    </div>
  </div>
</template>
